/**
 * Instagram feed grid — optional "load more" for posts beyond initial_visible.
 */
(function () {
  function init(section) {
    var grid = section.querySelector('[data-instagram-grid]');
    var btn = section.querySelector('[data-instagram-load-more]');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('.instagram-feed__item'));
    if (!items.length) return;

    var initial = parseInt(section.getAttribute('data-initial-visible') || '12', 10);
    if (isNaN(initial) || initial < 1) initial = 12;

    if (items.length <= initial) {
      if (btn) btn.hidden = true;
      return;
    }

    items.forEach(function (item, i) {
      if (i >= initial) item.classList.add('instagram-feed__item--hidden');
    });

    if (!btn) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      items.forEach(function (item) {
        item.classList.remove('instagram-feed__item--hidden');
      });
      btn.hidden = true;
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('.instagram-feed').forEach(function (section) {
      init(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    boot(evt.target);
  });
})();
